import React from 'react';
import CategoryAction from "../UI/Category/CategoryAction";

const CategoriesBar = () => {
  return (
    
    <div className="flex flex-col items-center gap-8 rounded-xl p-2 overflow-hidden">
      <CategoryAction/>
    </div>
  );
};

export default CategoriesBar;

